/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ReactComponent as MailIcon } from "cms/assets/icons/mail-outline.svg";
import { ReactComponent as PhoneIcon } from "cms/assets/icons/phone-in-talk-outline.svg";

const ContactCardItem = (props) => {
    const item = props?.item;
    const email = item?.email ?? "";
    const logoImageUrl = item?.logo ?? "";
    const orgName = item?.orgName ?? "";
    const phoneNumber = item?.phone ?? "";
    const websiteUrl = item?.url ?? "";

    return (
        <div className="contact-card-item">
            {logoImageUrl &&
                <a
                    className='contact-card-city-logo'
                    href={websiteUrl}
                    rel='noopener noreferrer'
                    target='_blank'
                >
                    <img src={logoImageUrl} alt='city-logo' />
                </a>
            }
            <div className="contact-card-content">
                {orgName && <h3>{orgName}</h3>}
                {email &&
                    <div className="contact-card-email">
                        <MailIcon alt="mail" />
                        <a href={`mailto:${email}`}>{email}</a>
                    </div>}
                {phoneNumber &&
                    <div className="contact-card-phone">
                        <PhoneIcon alt="phone" />
                        {phoneNumber}
                    </div>
                }
            </div>
        </div>
    );
};

ContactCardItem.displayName = "ContactCardItem";
export { ContactCardItem };
